import type { ProceduresResponse } from 'features/Procedure/state/procedure-api.type'
import { DrawMode, type DrawingElement } from 'features/Procedure/state/procedure.type'
import { normalizeDrawingDescriptionFromApi } from 'features/Procedure/utils/drawingDescription.utils'
import {
  shouldBackfillSimplify,
  simplifyFreeLinePoints,
} from 'features/Procedure/utils/freeLineSimplification'

const backfillSimplifyIfOversized = (el: DrawingElement): DrawingElement => {
  if (el.drawMode !== DrawMode.FREE_LINE) return el
  if (!Array.isArray(el.points) || !shouldBackfillSimplify(el.points.length)) return el
  return {
    ...el,
    points: simplifyFreeLinePoints(el.points),
    isModified: true,
  }
}

export const processDrawingsData = (data: ProceduresResponse): DrawingElement[] => {
  const drawings: DrawingElement[] = []
  const items = data?.items || []
  items.forEach((item) => {
    if (item.drawings) {
      const parsedDrawingElements = parseDrawingElements(item.drawings.drawingElements)
      const sortedDrawingElements = [...parsedDrawingElements].sort(
        (a, b) => a.timestamp - b.timestamp,
      )
      const drawingElements = sortedDrawingElements.map((el) =>
        backfillSimplifyIfOversized({
          ...el,
          procedureId: item.id,
          description: normalizeDrawingDescriptionFromApi(el.description as unknown),
        }),
      )
      drawings.push(...drawingElements)
    }
  })
  return drawings
}

const parseDrawingElements = (
  drawingElements: string | DrawingElement[] | undefined,
): DrawingElement[] => {
  if (!drawingElements) return []
  if (typeof drawingElements === 'string') return JSON.parse(drawingElements)
  return drawingElements
}

export const parseJsonString = <T>(jsonString: string | undefined | null): T | null => {
  if (!jsonString) return null
  if (typeof jsonString === 'string') return JSON.parse(jsonString) as T
  return jsonString as T
}
